/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { EcotransitBatchStatusResponseItemsInnerError } from './ecotransit-batch-status-response-items-inner-error';
// May contain unused imports in some cases
// @ts-ignore
import type { EcotransitCalculationResponse } from './ecotransit-calculation-response';

export interface EcotransitBatchStatusResponseItemsInner {
    'itemId': string;
    'status': EcotransitBatchStatusResponseItemsInnerStatusEnum;
    'result'?: EcotransitCalculationResponse;
    'error'?: EcotransitBatchStatusResponseItemsInnerError;
}

export enum EcotransitBatchStatusResponseItemsInnerStatusEnum {
    Pending = 'PENDING',
    Success = 'SUCCESS',
    Failed = 'FAILED'
}


